import React from "react";
import NewBDisplayBody from "./NewBDisplayBody";

const NewBDisplaySurvey = (props) => {
  const { actionsBtn, survey_code } = props;
  return <NewBDisplayBody actionsBtn={actionsBtn} survey_code={survey_code} />;
};

export default NewBDisplaySurvey;
